import { Component, OnInit, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-articulo-card',
  templateUrl: './articulo-card.component.html',
  styleUrls: ['./articulo-card.component.scss']
})
export class ArticuloCardComponent implements OnInit {

  imagenPosts = environment.rediImg + environment.posts;
  @Input()
  slug!: string;
  @Input()
  titulo!: string;
  @Input()
  imagen!: string;
  @Input()
  meta!: string;
  @Input()
  resumen!: string;

  constructor() { }

  ngOnInit(): void {
  }

  truncateHTML(text: string): string {
    let charlimit = 150;

    if (window.innerWidth < 675) {
      charlimit = 75;
    }

    if (!text || text.length <= charlimit) {
      return text;
    }
    let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
    let shortened = without_html.substring(0, charlimit) + "..." + "<strong>Continuar leyendo</strong>";
    return shortened;
  }

}
